// extracted by mini-css-extract-plugin
export default {"days":"SYjUolDGdMCDQe83dhMS","weekdays":"qVF0zlFoKCEY_j4_ktgJ","placeHolderShimmer":"Xq32IXf6jMAcz35khGOl"};